import ApiService from '../services/apiService';

const indexVoluntaryPensionFundsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/voluntary_pension_funds', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const exportVoluntaryPensionFundRequest = ({
  dispatch,
  format = '.xlsx',
  responseType = 'text',
  params = {},
  callback,
  successCallback
}) =>
  ApiService.request('get', `/voluntary_pension_funds/export${format}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });

export default indexVoluntaryPensionFundsRequest;
